import { useState } from 'react';
import {
  IComposableDashboardCollection,
  IComposableDashboardCollectionsContext,
  renameDashboardCollection,
} from 'wisestep-api';

import { success, failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

import { useComposableDashboardCollectionsContext } from './useComposableDashboardCollectionsContext';

const useRenameDashboard = () => {
  const { setDashboardCollections, setSelectedCollectionByIndex } =
    useComposableDashboardCollectionsContext() as Required<IComposableDashboardCollectionsContext>;
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [openUpdateDialog, setOpenUpdateDialog] = useState<boolean>(false);
  const onRenameDashboard = async (newDashboard: IComposableDashboardCollection) => {
    try {
      const response = await renameDashboardCollection(newDashboard);
      setDashboardCollections((prev) => {
        prev.splice(
          prev.findIndex((dashboard) => dashboard.id === newDashboard.id),
          1,
          response.data
        );
        return [...prev];
      });
      setNotification(success('Updated Dashboard collection Successfully!'));
    } catch (e) {
      setNotification(failed('Some error occurred. Please try later'));
    }
    setOpenUpdateDialog(false);
    setSelectedCollectionByIndex(-1);
  };

  return { onRenameDashboard, openUpdateDialog, setOpenUpdateDialog };
};
export default useRenameDashboard;
